// Static surah data for instant rendering (first 15 surahs)
// This eliminates API wait time for initial page load
// Full list loads in background and merges seamlessly

export const STATIC_SURAHS = [
  {
    id: 1,
    revelation_place: "makkah",
    revelation_order: 5,
    bismillah_pre: false,
    name_simple: "Al-Fatihah",
    name_complex: "Al-Fātiĥah",
    name_arabic: "الفاتحة",
    verses_count: 7,
    pages: [1, 1],
    translated_name: { language_name: "english", name: "The Opener" }
  },
  {
    id: 2,
    revelation_place: "madinah",
    revelation_order: 87,
    bismillah_pre: true,
    name_simple: "Al-Baqarah",
    name_complex: "Al-Baqarah",
    name_arabic: "البقرة",
    verses_count: 286,
    pages: [2, 49],
    translated_name: { language_name: "english", name: "The Cow" }
  },
  {
    id: 3,
    revelation_place: "madinah",
    revelation_order: 89,
    bismillah_pre: true,
    name_simple: "Ali 'Imran",
    name_complex: "Āli `Imrān",
    name_arabic: "آل عمران",
    verses_count: 200,
    pages: [50, 76],
    translated_name: { language_name: "english", name: "Family of Imran" }
  },
  {
    id: 4,
    revelation_place: "madinah",
    revelation_order: 92,
    bismillah_pre: true,
    name_simple: "An-Nisa",
    name_complex: "An-Nisā",
    name_arabic: "النساء",
    verses_count: 176,
    pages: [77, 106],
    translated_name: { language_name: "english", name: "The Women" }
  },
  {
    id: 5,
    revelation_place: "madinah",
    revelation_order: 112,
    bismillah_pre: true,
    name_simple: "Al-Ma'idah",
    name_complex: "Al-Mā'idah",
    name_arabic: "المائدة",
    verses_count: 120,
    pages: [106, 127],
    translated_name: { language_name: "english", name: "The Table Spread" }
  },
  {
    id: 6,
    revelation_place: "makkah",
    revelation_order: 55,
    bismillah_pre: true,
    name_simple: "Al-An'am",
    name_complex: "Al-'An`ām",
    name_arabic: "الأنعام",
    verses_count: 165,
    pages: [128, 150],
    translated_name: { language_name: "english", name: "The Cattle" }
  },
  {
    id: 7,
    revelation_place: "makkah",
    revelation_order: 39,
    bismillah_pre: true,
    name_simple: "Al-A'raf",
    name_complex: "Al-'A`rāf",
    name_arabic: "الأعراف",
    verses_count: 206,
    pages: [151, 176],
    translated_name: { language_name: "english", name: "The Heights" }
  },
  {
    id: 8,
    revelation_place: "madinah",
    revelation_order: 88,
    bismillah_pre: true,
    name_simple: "Al-Anfal",
    name_complex: "Al-'Anfāl",
    name_arabic: "الأنفال",
    verses_count: 75,
    pages: [177, 186],
    translated_name: { language_name: "english", name: "The Spoils of War" }
  },
  {
    id: 9,
    revelation_place: "madinah",
    revelation_order: 113,
    bismillah_pre: false,
    name_simple: "At-Tawbah",
    name_complex: "At-Tawbah",
    name_arabic: "التوبة",
    verses_count: 129,
    pages: [187, 207],
    translated_name: { language_name: "english", name: "The Repentance" }
  },
  {
    id: 10,
    revelation_place: "makkah",
    revelation_order: 51,
    bismillah_pre: true,
    name_simple: "Yunus",
    name_complex: "Yūnus",
    name_arabic: "يونس",
    verses_count: 109,
    pages: [208, 221],
    translated_name: { language_name: "english", name: "Jonah" }
  },
  {
    id: 11,
    revelation_place: "makkah",
    revelation_order: 52,
    bismillah_pre: true,
    name_simple: "Hud",
    name_complex: "Hūd",
    name_arabic: "هود",
    verses_count: 123,
    pages: [221, 235],
    translated_name: { language_name: "english", name: "Hud" }
  },
  {
    id: 12,
    revelation_place: "makkah",
    revelation_order: 53,
    bismillah_pre: true,
    name_simple: "Yusuf",
    name_complex: "Yūsuf",
    name_arabic: "يوسف",
    verses_count: 111,
    pages: [235, 248],
    translated_name: { language_name: "english", name: "Joseph" }
  },
  {
    id: 13,
    revelation_place: "madinah",
    revelation_order: 96,
    bismillah_pre: true,
    name_simple: "Ar-Ra'd",
    name_complex: "Ar-Ra`d",
    name_arabic: "الرعد",
    verses_count: 43,
    pages: [249, 255],
    translated_name: { language_name: "english", name: "The Thunder" }
  },
  {
    id: 14,
    revelation_place: "makkah",
    revelation_order: 72,
    bismillah_pre: true,
    name_simple: "Ibrahim",
    name_complex: "Ibrāhīm",
    name_arabic: "ابراهيم",
    verses_count: 52,
    pages: [255, 261],
    translated_name: { language_name: "english", name: "Abraham" }
  },
  {
    id: 15,
    revelation_place: "makkah",
    revelation_order: 54,
    bismillah_pre: true,
    name_simple: "Al-Hijr",
    name_complex: "Al-Ĥijr",
    name_arabic: "الحجر",
    verses_count: 99,
    pages: [262, 267],
    translated_name: { language_name: "english", name: "The Rocky Tract" }
  }
];

// Total surahs count (for progress indicators)
export const TOTAL_SURAHS = 114;
